import ReactMarkdown from "react-markdown";
import type { Components } from "react-markdown";
import remarkGfm from "remark-gfm";

const markdownComponents: Components = {
  h2: ({ children }) => (
    <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4 first:mt-0">
      {children}
    </h2>
  ),
  h3: ({ children }) => (
    <h3 className="text-xl font-semibold text-foreground mt-6 mb-3">
      {children}
    </h3>
  ),
  p: ({ children }) => (
    <p className="text-base leading-7 text-foreground mb-4 last:mb-0">
      {children}
    </p>
  ),
  strong: ({ children }) => (
    <strong className="font-semibold">{children}</strong>
  ),
  em: ({ children }) => <em className="italic">{children}</em>,
  ul: ({ children }) => (
    <ul className="list-disc pl-5 space-y-2 mb-4 text-base">{children}</ul>
  ),
  ol: ({ children }) => (
    <ol className="list-decimal pl-5 space-y-2 mb-4 text-base">{children}</ol>
  ),
  li: ({ children }) => (
    <li className="text-base leading-7 text-foreground">{children}</li>
  ),
  blockquote: ({ children }) => (
    <blockquote className="border-l-2 border-primary/40 pl-4 my-4 text-muted-foreground italic">
      {children}
    </blockquote>
  ),
  hr: () => <hr className="my-8 border-border" />,
  table: ({ children }) => (
    <table className="w-full mb-4">{children}</table>
  ),
  thead: ({ children }) => (
    <thead className="border-b border-border">{children}</thead>
  ),
  th: ({ children }) => (
    <th className="text-left px-3 py-2 font-semibold text-sm">{children}</th>
  ),
  td: ({ children }) => (
    <td className="px-3 py-2 border-t border-border text-sm">{children}</td>
  ),
};

export function MarkdownRenderer({
  content,
  components,
}: {
  content: string;
  /** Per-call overrides merged over the shared defaults (e.g. chat's citation-chip anchor). */
  components?: Components;
}) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={components ? { ...markdownComponents, ...components } : markdownComponents}
    >
      {content}
    </ReactMarkdown>
  );
}
